export default __webpack_public_path__ + "static/media/kanit-regular.b4ce5ca4.svg";